<template>
  <el-row>
    <el-col :span="12">
      <div class="title">
        <week-navigator :next-path="previousWeekPath" base-path="/admin" previous-week />
        <h1>{{ orderDates }}</h1>
        <week-navigator :next-path="nextWeekPath" base-path="/admin" />
      </div>
    </el-col>
    <el-col :span="5">
      <span id="location">{{ $t('orderList.location') }}</span>
      <office-dropdown :selected="adminSelectedOffice" @change="onOfficeChanged" />
    </el-col>
    <el-col :span="5">
      <span>{{ $t('global.company') }}</span>
      <company-dropdown :selected="adminSelectedCompany" @change="onCompanyChanged" />
    </el-col>
    <el-col :span="2">
      <div v-if="isDataToExport" class="buttons-container">
        <div class="button-wrapper">
          <download-csv :data="this.export" :name="this.reportName">
            <el-button class="button">{{ $t('orderList.export') }}</el-button>
            <span class="hint-message">{{ $t('orderList.exportHint') }}</span>
          </download-csv>
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import { mapState } from 'vuex';
import moment from 'moment';
import WeekNavigator from '@/components/WeekNavigator';
import OfficeDropdown from '@/components/OfficeDropdown';
import CompanyDropdown from '@/components/CompanyDropdown';
import { getWeekStartAndEndDate, parseWeek, formatWeek } from '@/helpers';

export default {
  components: {
    WeekNavigator,
    OfficeDropdown,
    CompanyDropdown,
  },
  props: {
    export: {
      type: Array,
      required: false,
      default: () => [],
    },
    reportName: {
      type: String,
      required: false,
      default: 'data.csv',
    },
  },
  computed: {
    ...mapState('weeklyMenu', {
      weekNumber: (state) => state.weekNumber,
      selectedWeek: (state) => state.selectedWeek,
    }),
    ...mapState('global', {
      adminSelectedOffice: 'adminSelectedOffice',
      adminSelectedCompany: 'adminSelectedCompany',
    }),
    orderDates() {
      const weekDates = getWeekStartAndEndDate(this.weekNumber);

      return `
        ${this.$t('orderReport.ordersFor')}
        ${weekDates.startDate.format('MMMM DD')}
        ${this.$t('orderReport.to')}
        ${weekDates.endDate.format('MMMM DD')}
      `;
    },
    isDataToExport() {
      return Object.keys(this.export).length > 0;
    },
    previousWeekPath() {
      return this.getNextPath(true);
    },
    nextWeekPath() {
      return this.getNextPath(false);
    },
  },
  methods: {
    onOfficeChanged(office) {
      this.$emit('officechanged', office);
    },
    onCompanyChanged(company) {
      this.$emit('companychanged', company);
    },
    getNextPath(isPreviousWeek) {
      const nextWeek = parseWeek(this.selectedWeek);
      if (isPreviousWeek) nextWeek.subtract(1, 'week');
      else nextWeek.add(1, 'week');
      const nextWeekString = formatWeek(nextWeek);
      const currentWeekString = formatWeek(moment());
      return nextWeekString !== currentWeekString ? nextWeekString : '';
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../scss/variables';

.title {
  font-weight: $bold-font;
  font-size: $title-font-size;
  width: 600px;
  display: flex;
  justify-content: space-between;
}

.buttons-container {
  .button-wrapper {
    display: inline-block;
  }
  .button,
  .hint-message {
    display: block;
  }
  .hint-message {
    font-size: $label-description-text-size;
    text-align: center;
    color: $order-button-hint;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/orders/SummaryNavigator.vue